<script>
  export let count = 2;
  export let isIso = true;

  const flatWidth = 4;
  const flatHeight = 5;
  $: getCount = (j) => {
    const i = j; 
    const c = Math.round(count);
    return (c - (i * flatHeight)) > flatHeight ? flatHeight : (c - (i * flatHeight))
  };

  $: getOffset = (i) => {
    return Math.floor(Math.abs(flatBlocks - (i + 1)) / flatWidth);
  }

  $: flatBlocks = Math.ceil(count / flatHeight);
</script>
{#each Array(flatBlocks).fill(0) as block, i}
<div  class="svg-container"
      class:isIso 
      style="z-index:{Math.floor(i / flatWidth)}; 
              bottom:{100 + Math.floor((flatBlocks - i + 1) / flatWidth) * 25}px; 
              left:{180 + (i % flatWidth) * 55}px;">

<svg id="flat" height={45 + getCount(i) * 20} class="container">
  {#each Array(Math.round(getCount(i))).fill(0).map((d, i) => i).sort((a, b) => b - a) as i}
    <svg
      width="60"
      height="45"
      class="flat"
      y={i * 20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 85.47 70.7">
      <defs>
        <style>.cls-1,.cls-2,.cls-3{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#777;}.cls-3{fill:#fff;}</style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <polygon class="cls-1" points="84.36 51.33 42.34 70.13 1.22 51.33 42.34 30.47 84.36 51.33" />
          <polygon class="cls-2" points="1.15 21.73 42.18 40.8 83.41 21.73 83.41 48.91 42.28 67.39 1.15 48.96 1.15 21.73" />
          <polygon class="cls-2" points="84.3 21.42 42.28 40.22 1.15 21.42 42.28 0.56 84.3 21.42" />
          <polygon class="cls-3" points="18.73 43.91 4.8 37.41 4.95 29.83 18.88 36.33 18.73 43.91" />
          <polygon class="cls-3" points="36.69 52.45 22.75 45.95 22.9 38.36 36.83 44.86 36.69 52.45" />
          <polygon class="cls-3" points="62.35 45.37 48.27 52.15 48.42 44.56 62.5 37.78 62.35 45.37" />
          <polygon class="cls-3" points="80.32 36.33 66.24 43.11 66.39 35.53 80.47 28.75 80.32 36.33" />
      </g>
      </g>
    </svg>
  {/each}
</svg>
</div>
{/each}

<style>
  div.svg-container {    
    position: absolute;
    bottom: 120px;
    left: 200px;
    opacity: 0;
    width: 50px;
    transition: 0.5s opacity;
  }

  svg.container {
    width: 60px;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  div.svg-container.isIso {
    opacity: 1;
  }

  svg.flat {
    width: 60px;
    height: 45x;
  }
</style>
